module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_6000.12e83e59.png";